/**
 * @description：常用的 HTTP 状态码
 */
export const HTTP_STATUS_CODE = {
    SUCCESS: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    UPDATE_REQUEST: 426,
    SERVER_ERROR: 500,
    SERVER_UNAVAILABLE: 503,
  } as const;
  
  export type HTTP_STATUS_CODE = keyof typeof HTTP_STATUS_CODE;
  
  export const INTERNAL_ERROR_CODE = {
    UNKNOWN: -1, // 未知错误
    CANCELLED: -2, // 请求被取消
    TIMEOUT: -3, // 请求超时
    NETWORK: -4, // 网络错误
  } as const;
  
  export type INTERNAL_ERROR_CODE = keyof typeof INTERNAL_ERROR_CODE;